import { Outlet } from 'react-router-dom';
import TabelaGrupoMinisterio from './components/tabela';

export default function GrupoCelula() {

  return (
    <>
      <Outlet/>
      <TabelaGrupoMinisterio />
    </>
  )
}
